import React, { useMemo } from 'react';
import classNames from 'classnames';
import { FieldRenderProps } from 'react-final-form';
import ResolveMultiSelect from '../ResolveMultiSelect';
import { ResolveMultiSelectProps } from '../ResolveMultiSelect/types';
import FieldWrapper from 'components/FieldWrapper';
import { FieldWrapperProps } from 'components/FieldWrapper/FieldWrapper.component';

import './ResolveMultiSelectField.styles.scss';

type ResolveMultiSelectFieldProps = FieldWrapperProps &
  ResolveMultiSelectProps<string> &
  FieldRenderProps<Array<string>, HTMLElement>;

const ResolveMultiSelectField: React.FC<ResolveMultiSelectFieldProps> = (
  props,
) => {
  const {
    className,
    input,
    meta: { touched, error },
    ...rest
  } = props;

  const hasError = useMemo(() => touched && error, [error, touched]);

  const classes = classNames(
    'resolve-multi-select-field',
    { 'resolve-multi-select-field--error': hasError },
    className,
  );

  return (
    <FieldWrapper
      className={classes}
      error={error}
      hasError={hasError}
      {...rest}
    >
      <ResolveMultiSelect
        className={classes}
        {...rest}
        {...input}
        hasError={hasError}
      />
    </FieldWrapper>
  );
};

export default ResolveMultiSelectField;
